<template>
  <div>
    <div class="intensive-test__question">
      <div class="_fs-16 _lh-24 _tc-dark-grey _mb-2">
        {{
          $t('pages.intensive_detail.test.question.title') +
          ' ' +
          parseInt(qInd + 1)
        }}
      </div>
      <div class="_fs-24 _lh-32 _tc-dark _mb-6">
        {{ getTranslate(question).title }}
      </div>
      <div
        class="intensive-test__answers"
        :class="{ 'intensive-test__question_blocked': blocked }"
      >
        <Answer
          @blockQuestion="blockQuestion"
          @addCorrectAnswer="addCorrectAnswer"
          v-for="(answer, aInd) in answersSort"
          :key="aInd"
          :aInd="aInd"
          :answer="answer"
        />
      </div>
    </div>
    <div class="d-flex _mt-8">
      <AppBtn
        :btnClass="'btn_secondary'"
        :disabled="qInd === 0"
        @click.native="prevQuestion"
        ><span class="_fs-16 _lh-24 _py-4 _px-4">{{
          $t('interface.back')
        }}</span>
      </AppBtn>
      <AppBtn @click.native="nextQuestion" class="_ml-auto"
        ><span class="_fs-16 _lh-24 _py-4 _px-4">{{
          $t('interface.next')
        }}</span>
      </AppBtn>
    </div>
  </div>
</template>

<script>
import Answer from './Answer.vue'
import AppBtn from '@/components/UI/buttons/AppBtn.vue'
export default {
  name: 'Question',
  data: () => ({
    correctAnswers: 0,
    blocked: false,
  }),
  components: {
    Answer,
    AppBtn,
  },
  props: {
    question: Object,
    qInd: Number,
  },
  computed: {
    correctAnswersCount() {
      return this.question.answers.filter((el) => el.is_correct).length
    },
    answersSort() {
      return this.question.answers.slice(0).sort(() => Math.random() - 0.5)
    },
  },
  methods: {
    getTranslate(item) {
      return item.translates[0]
    },
    prevQuestion() {
      this.$emit('prevQuestion', this.qInd - 1)
    },
    nextQuestion() {
      this.$emit('nextQuestion', this.qInd + 1)
    },
    blockQuestion() {
      this.blocked = true
    },
    addCorrectAnswer() {
      this.correctAnswers++
    },
  },
  watch: {
    correctAnswers() {
      if (this.correctAnswers === this.correctAnswersCount) {
        this.blocked = true
        this.$emit('addCorrectQuestion')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.intensive-test {
  &__question {
    &_blocked {
      opacity: 0.7;
      pointer-events: none;
    }
  }
}
</style>
